export const arcLayerProps = {
  id: 'animated-arc-layer',
  pickable: false,
  getTilt: 1,
  animationSpeed: 0.002,
};
